import { render, staticRenderFns } from "./FormTratamiento.vue?vue&type=template&id=170a7e01&scoped=true"
import script from "./FormTratamiento.vue?vue&type=script&lang=js"
export * from "./FormTratamiento.vue?vue&type=script&lang=js"
import style0 from "./FormTratamiento.vue?vue&type=style&index=0&id=170a7e01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a7e01",
  null
  
)

export default component.exports